import { render, staticRenderFns } from "./IconBillingStaticData.vue?vue&type=template&id=5d3866da"
import script from "./IconBillingStaticData.vue?vue&type=script&lang=js"
export * from "./IconBillingStaticData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports